export default {"src":"/_next/static/media/magnifyingGlass_40.071068c8.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};